import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaIssue } from 'src/apps/mfa/services/MfaSingleSessionService';
import { IMfaIssueData } from 'src/apps/mfa/services/queries/issue/helpers/transformResults';
import { MFA_ISSUE } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaIssueQuery = (
	issueId: string,
	runId: string
): UseQueryResult<IMfaIssueData | null> => {
	const issueQuery = useQuery([MFA_ISSUE, issueId, runId], () => getMfaIssue(issueId, runId));

	return issueQuery;
};
